// OneTrust reports category/group IDs as full codes (e.g. "C0001", "C0010") in some
// SDK versions and as bare numbers (e.g. "1", "10") in others. Strip any "C0*" prefix
// so group IDs of any digit length normalize to the same bare-number representation
// regardless of source or category count.
export function normalizeOneTrustGroupId(id: string): string {
  return id.replace(/^C0*/, '');
}

/**
 * Groups already recorded in the OptanonConsent cookie (i.e. the user has made,
 * or OneTrust has recorded, a consent choice). Returns undefined when no such
 * cookie exists yet (first visit, before any interaction/default resolution).
 */
export function getOneTrustCookieActiveGroups(): string[] | undefined {
  if (typeof document === 'undefined') return undefined;

  // Raw OptanonConsent cookie is URL-encoded, e.g. groups=C0001%3A1%2CC0004%3A0
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('OptanonConsent='))
    ?.split('groups=')[1]
    ?.split('&')[0]
    ?.split('%2C') // %2C = comma separator between groups
    ?.filter((item) => item.endsWith('1')) // groups ending in ':1' (%3A1) are opted-in
    ?.map((item) => normalizeOneTrustGroupId(item.split('%')[0]));
}

/**
 * Groups OneTrust's SDK currently considers active. Before any user consent action,
 * this reflects the admin-configured default toggle state for each category — any
 * number of categories/sliders, on or off — not just "strictly necessary".
 */
export function getOneTrustActiveGroups(): string[] {
  if (typeof window === 'undefined') return [];
  return String(window.OnetrustActiveGroups || window.OptanonActiveGroups || '')
    .split(',')
    .filter(Boolean)
    .map(normalizeOneTrustGroupId);
}
